import { render, staticRenderFns } from "./bit.vue?vue&type=template&id=72278d34&scoped=true"
import script from "./bit.vue?vue&type=script&lang=js"
export * from "./bit.vue?vue&type=script&lang=js"
import style0 from "./bit.vue?vue&type=style&index=0&id=72278d34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72278d34",
  null
  
)

export default component.exports